// @ts-nocheck — 디자인 원본 스크립트 포팅 (home-v2.js)
import type { Scope } from './scope';

/** 홈: 등장 애니메이션(.rv), data-tabs 탭, 히어로 관리자/사용자 포탈 자동 전환(.hsw), 스텝 네비 */
export function initHomeTabs(root: ParentNode, s: Scope) {
  const { setTimeout, setInterval, clearTimeout, clearInterval } = s;
  const io = new IntersectionObserver(
    (es) =>
      es.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      }),
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
  );
  s.onDispose(() => io.disconnect());

  root.querySelectorAll('.rv').forEach((el) => io.observe(el));

  root.querySelectorAll('[data-tabs]').forEach((g) => {
    const btns = g.querySelectorAll('[data-t]'),
      pans = g.querySelectorAll('[data-p]');
    const set = (k) => {
      btns.forEach((b) => b.classList.toggle('on', b.dataset.t === k));
      pans.forEach((p) => p.classList.toggle('on', p.dataset.p === k));
    };
    btns.forEach((b) => b.addEventListener('click', () => set(b.dataset.t)));
    if (g.hasAttribute('data-auto')) {
      let i = 0;
      const ks = [...btns].map((b) => b.dataset.t);
      const t = setInterval(() => {
        i = (i + 1) % ks.length;
        set(ks[i]);
      }, 4200);
      g.addEventListener('click', () => clearInterval(t), { once: true });
    }
  });

  root.querySelectorAll('.hsw').forEach((sw) => {
    const bs = [...sw.querySelectorAll('.htabs button')],
      ps = [...sw.querySelectorAll('.hpan')];
    let t;
    const go = (k) => {
      bs.forEach((b) => b.classList.remove('on'));
      void sw.offsetWidth;
      bs.forEach((b, j) => b.classList.toggle('on', j === k));
      ps.forEach((p, j) => p.classList.toggle('on', j === k));
      const d = +ps[k].dataset.dur || 6000;
      bs[k].style.setProperty('--d', d + 'ms');
      if (ps[k].dataset.h === 'a' && window.__demoPlay) window.__demoPlay();
      clearTimeout(t);
      t = setTimeout(() => go((k + 1) % ps.length), d);
    };
    bs.forEach((b, j) => b.addEventListener('click', () => go(j)));
    go(0);
  });

  const steps = root.querySelectorAll('[data-step]');
  if (steps.length) {
    const so = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (e.isIntersecting) {
            const k = e.target.dataset.step;
            root.querySelectorAll('[data-stepnav]').forEach((n) => n.classList.toggle('on', n.dataset.stepnav === k));
          }
        }),
      { rootMargin: '-45% 0px -45% 0px' },
    );
    steps.forEach((el) => so.observe(el));
    s.onDispose(() => so.disconnect());
  }
}
